import axios from "axios";
// import lodash if you need it across all files
// import _ from 'lodash';

const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");

// Setup global defaults here, if needed
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
axios.defaults.baseURL = appbaseurl;

// Export any configuration or defaults that you want to use globally
export const config = {
    baseurl: appbaseurl, // You can modify this according to your app's environment
    uploadurl: "/media/upload",
    deleteurl: "/media/delete/",
    storageurl: `${appbaseurl}/storage/`,
    downloadurl: "/media/browser",
    formtoken: csrfToken || "",
};

export const toolbar = 
  "insert | image link media | codeeditor bootstrap4grid | undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat";

export const tinyOptions ={
    plugins:"print preview advlist autolink table lists image media link imagetools paste help wordcount fullscreen autoresize bootstrap4grid codeeditor",
    height: 500,
    content_style: "body { margin: 0.5rem auto; max-width: 95%; }",
    codeeditor_font_size: 15,
    codeeditor_themes_pack: ["dawn", "twilight", "kuroir"],
    file_picker_callback: function (callback, value, meta) {
        var x =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.getElementsByTagName("body")[0].clientWidth;
        var y =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.getElementsByTagName("body")[0].clientHeight;

        if (meta.filetype == "image") {
            //call my own file uploader
            //open file browser
            //callback(image,{title:image.name});
        }
    },
};
// You don't need to assign Vue to window anymore in Vue 3.
// Vue 3 uses createApp to handle instances, and doesn't require global Vue objects.
// This file can now be imported wherever needed without adding it to the global `window` object.

export default axios;
